import httpInstance from '../httpInstance';

const editRootnessDocument = async (body) => {
  const endpoint = '/back-office/v1/rootness-document/';
  let res;
  await httpInstance.put(
    endpoint,
    body,
  ).then((dataResponse) => {
    res = dataResponse;
  }).catch((err) => {
    res = err.response;
  });
  return res;
};

export default editRootnessDocument;
